import React, {useCallback, useEffect, useState} from 'react';
import axios from "axios";
import ENV from "../ENV.json";
import {useHistory} from "react-router-dom";
import Popup from "./Popup";
import {Box, Divider, Flex, Text} from "@chakra-ui/react";
import PointOfInterestForm from "./PointOfInterestForm";
import SearcherPOI from './SearcherPOI';
import Loading from "./Loading";
import {reactLocalStorage} from "reactjs-localstorage";


const EditorPointOfInterest = (props) => {

    const history = useHistory();
    //Elenco di tutti i POI inseriti in piattaforma (BackEnd).
    const [allPoiName, setAllPoiName] = useState([]);
    const [allPoiNameDownloading, setAllPoiNameDownloading] = useState(false);

    //POPUPS
    const [modalOpen, setModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({});

    //POI Soggetto alla modifica
    const [crrPoi, setCrrPoi] = useState(null);
    const [crrPoiDownloading, setCrrPoiDownloading] = useState(false);

    //Fetch all POI
    useEffect(() => {

        const User = reactLocalStorage.getObject('User');
        console.log("Abbiamo trovato un User -> "+User);
        if(!User) history.push('/');

        setAllPoiNameDownloading(true);
        axios.get(`${ENV[ENV.ENV_STATE].baseUrl}/get/all/poi`, {withCredentials: true, credentials: 'include'})
            .then(function (response) {
                if (response?.data?.status) {
                    //console.log(response?.data?.rows);
                    setAllPoiName(response?.data?.rows);
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare le categorie. Ricarica la pagina"
                })
                setModalOpen(true);
                if (error.response.status === 403) {
                    history.push('/')
                }
            })
            .then(function (response) {
                setAllPoiNameDownloading(false)
            });
    }, []);

    const editPOI = useCallback((ID) => {
        setCrrPoiDownloading(true);
        setCrrPoi(null);
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/get/poi`, {"ID": ID})
            .then(function (response) {
                if (response?.data?.status) {
                    //console.log(response?.data?.rows);
                    setCrrPoi(response?.data?.rows);
                } else {
                    setPopupData(response?.data);
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare il punto di interesse"
                })
                setModalOpen(true);
                if (error?.response?.status === 403) {
                    history.push('/')
                }
            })
            .then(function (response) {
                setCrrPoiDownloading(false)
            });
    }, [])

    const editTempPoi = useCallback((_id) => {
        setCrrPoiDownloading(true);
        axios.post(`${ENV[ENV.ENV_STATE].baseUrl}/get/single/poi/temp`, {"__id": _id})
            .then(function (response) {
                if (response?.data?.status) {
                    //console.log(response?.data?.result);
                    setCrrPoi(response?.data?.result);
                    console.log(response?.data?.result)
                } else {
                    setPopupData(response?.data)
                    setModalOpen(true);
                }
            })
            .catch(function (error) {
                setPopupData({
                    status: false,
                    title: "Errore imprevisto",
                    message: "Non è stato possibile caricare il punto di interesse salvato"
                })
                setModalOpen(true);
                if (error?.response?.status === 403) {
                    history.push('/')
                }
            })
            .then(function (response) {
                setCrrPoiDownloading(false)
            });
    }, []);


    return (
        <Box {...props?.pageProps}>
            <Flex flexDirection={"column"} gap='10px'>
                <SearcherPOI
                    onSelectedPoi={(ID_POI) => {
                        editPOI(ID_POI);
                    }}
                    onSelectedTempPoi={(_id) => {
                        //Viene invocata dai poi temporanei
                        editTempPoi(_id);
                    }}
                />
                <Divider/>
                <Text fontWeight="bold">ZONA DI MODIFICA DI UN PUNTO DI INTERESSE</Text>
                <Flex flexDirection={"row"} padding={"10px"}>
                    {
                        crrPoi == null ?
                            <Text> Clicca su uno dei punti di interesse presenti nella base dati in modo da iniziare a
                                modificarlo</Text>
                            :
                            <div>
                                <PointOfInterestForm
                                    key={crrPoi?._id}
                                    startPos={{lat: crrPoi?.lat, lng: crrPoi?.longitude}}
                                    edit={true}
                                    data={crrPoi || null}
                                />
                            </div>
                    }
                </Flex>
                <Popup isOpen={modalOpen} onClose={() => setModalOpen(false)} popupData={popupData}/>
                <Loading isLoading={crrPoiDownloading || allPoiNameDownloading}/>
            </Flex>
        </Box>
    );
};

export default EditorPointOfInterest;
